// src/config.js
//const API_BASE_URL = "https://localhost:44315/api";
//const API_BASE_URL = "http://69.169.111.100/profit/api";
const API_BASE_URL = "https://profiterp.online/profit/api";

export default API_BASE_URL;

